import * as actionTypes from "./actionTypes";
import axios from "axios";

export const initGetDealer = () => {
    return {
        type: actionTypes.INIT_GET_DEALER,
        loadingDealer: true
    }
};

export const successGetDealer = (dealer) => {
    return {
        type: actionTypes.SUCCESS_GET_DEALER,
        loadingDealer: false,
        dealer: dealer,

    }
};

export const failGetDealer = (error) => {
    return {
        type: actionTypes.FAIL_GET_DEALER,
        loadingDealer: false,
        error: error
    }
};


export const getDealer = (dealerId) => {
    return dispatch => {
        dispatch(initGetDealer())
        axios.get(`dealers/${dealerId}`)
            .then((response) => {
                dispatch(successGetDealer(response.data))
            })
            .catch(error => {
                failGetDealer(error.message)
            })
    }
};

// ################### GET DEALER POSTS :

export const initGetDealerPosts = ()=>{
    return {
        type: actionTypes.INIT_GET_DEALER_POSTS,
        loadingDealer: true
    }
};

export const successGetDealerPosts = (data)=>{
    return {
        type: actionTypes.SUCCESS_GET_DEALER_POSTS,
        loadingDealer: false,
        dealerPosts : data
    }
};

export const failGetDealerPosts = (error)=>{
    return {
        type: actionTypes.INIT_GET_DEALER_POSTS,
        loadingDealer: false,
        error: error
    }
};

export const getDealerPosts = (dealerID, pageNum) => {
    let url = `all/lists?seller_id=${dealerID}&per_page=10`;
    if (pageNum){
        url = `all/lists?seller_id=${dealerID}&per_page=10&page=${pageNum}`
    }
    return dispatch => {
        dispatch(initGetDealerPosts())
        axios.get(url)
            .then(response => {
                dispatch(successGetDealerPosts(response.data))
            })
            .catch(error => {
                dispatch(failGetDealerPosts(error.message))
            })
    }
}